"use strict";
// (C) 2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./SyntaxHighlightingInput"), exports);
//# sourceMappingURL=index.js.map